var BraintreeThreeDS = (function (braintree, $) {

    var BraintreeThreeDS = function (opts) {
        this.$created = new $.Deferred();
        this.instance = null;
        $.extend(this, opts);
    };

    $.extend(BraintreeThreeDS.prototype, {
        init: function (clientInstance) {
            var callback = $.proxy(this._callback, this, clientInstance);

            braintree.threeDSecure.create({
                client: clientInstance
            }, callback);

            return this.$created.promise();
        },
        _callback: function (clientInstance, createErr, instance) {
            if (!createErr) this.instance = instance;
            this.$created.resolve(clientInstance);
        },
        verifyCard: function (amount, nonce) {
        	var $verify = new $.Deferred();
        	var $ready = new $.Deferred();
            var callback = $.proxy(this._verifyCallback, this, $verify);
            var form = $('<div>').addClass('threeds-wrapper');

            this.instance.verifyCard({
                    nonce: nonce,
                    amount: amount,
                    addFrame: function (err, iframe) {
                    	form.append(iframe);
                        $ready.resolve(form, $verify.promise());
                    },
                    removeFrame: function () {
                    	form.remove();
                    }
                }, callback);

	        return {
		        verify: $verify.promise(),
		        ready: $ready.promise()
	        };
        },
        cancelVerifyCard: function () {
        	this.instance.cancelVerifyCard();
        },
        _verifyCallback: function ($verify, err, payload) {
            if (err) {
                $verify.reject({error: err});
            } else {
                var details = payload.verificationDetails || payload;
            	$verify.resolve({
            		Nonce: payload.nonce,
                    Token: null,
                    IneligibleFor3D: !details.liabilityShifted && !details.liabilityShiftPossible
            	});
            }
        },
        isEnabled: function () {
            return !!this.instance;
        }
    });

    return BraintreeThreeDS;
})(window.braintree, jQuery);